module.exports = __webpack_public_path__ + "img/topup_details.1f3ffeb7.svg";